export default __webpack_public_path__ + "static/media/TrashLight.0fd03a4d.svg";